
	const texts = {
		ede: {
			empty_agenda_text: 'Geen resultaten',
			empty_agenda_subtext: 'Helaas hebben we op dit moment geen items gevonden die overeenkomen met jouw voorkeuren.',
			agenda_date_name: 'Datum',
			agenda_date_today: 'Vandaag',
			agenda_date_tomorrow: 'Morgen',
			agenda_date_all: 'Alle dagen',

			agenda_location_name: 'Locatie',
			agenda_location_all: 'Alle locaties',
			agenda_location_filter_selected: 'locaties geselecteerd',

			agenda_tag_name: 'Interesses',
			agenda_tag_all: 'Alle interesses',
			agenda_tag_selected: 'interesses geselecteerd',

			agenda_audience_name: 'Ik ben',

			agenda_category_name: 'Ik wil naar',

			agenda_free_name: 'Gratis',
			agenda_discount_name: 'Korting',

			agenda_filter_choose: 'Kies',
			agenda_filter_selected: 'Geselecteerd',
			agenda_delete_filters: 'Wis filter',
			agenda_filter_button_mobile: 'Filter',

			agenda_results_single: 'resultaat',
			agenda_results: 'resultaten',

			agenda_tile_from: 'Vanaf',
			agenda_tile_tickets: 'Tickets & Tijden',
			agenda_tile_info: 'Meer info',
			agenda_show_soldout: 'UITVERKOCHT',
		},
	}

	window.customData.childTheme = 'ede'; //SET THIS
	window.customData.i18n = texts[window.customData.childTheme];

/**
* Contains React app configuration for each child

* Main configuration:
* @param {string} name - the display name of the child
* @param {string} theme - slug for child theme
* @param {string} feedUrl - the url for the feed
* @param {string} custom_post_type - the custom post type that is retrieved from the feed
* @param {Boolean} multiLanguage - using eng/dutch (true) or only dutch (false)
* @param {Boolean} hide_on_home_desktop - by default this app shows on homepage, but most sites hide this on desktop
* @param {String} empty_agenda_text - text that is shown on empty state
* @param {String} loading_svg - name of svg used for loader ("Camera"/"KinoLoader" or null)
* @param {Boolean} agenda_listing_with_months - horizontal agenda listing with month seperators (true) or only simple cards without months in case of courses (false)
* @param {Boolean} sort_by_date - sort movies by date (true) or popularity (false)

* Movie tile configuration
* @param {Boolean/String} showtime_undertitle - in movie tile, what is displayed underneath each show time (e.g. venue, room) or false for nothing
* @param {String} card_type - choose between two different designs, either "filmhallen" or "bioscopenleiden"
* @param {String} agenda_tile_type - choose between different designs: "small", "big", or "both" (for variation according to sort option)
* @param {String} big_title_agendatext - choose between "storyline" or "synopsis" (or null if no big tile)
* @param {Boolean} big_tile_date_short - use specific date view that only displays first letters of month/weekday (if in big tile)
* @param {Boolean} show_movie_info_in_tile - show director name, country, duration (if in big tile)
* @param {Boolean} show_movie_review_in_tile - show review (if in big tile)
* @param {Boolean} year_in_tile - show year in date display
* @param {Number} promo_cards_frequency - if set, this indicates the frequency of rendering promotion tiles in the array of agenda tiles

* Filterbar configuration
* @param {String} filterbar_type - choose between "dropdowns" (for courses) or "overlay" (for agenda)
* @param {Boolean} has_cinema_selector - in case of multiple locations/cinemas for one site, this feature can filter out specific cinema
* @param {Boolean} has_sorting_option - feature to manually switch/toggle between showing 1) movies sorted by popularity or 2) individual showtimes
* @param {Boolean} sorting_option_mobile_nonemodal - option for a second sorting toggle above filterbar on closed modal
* @param {Number} minimum_days_in_filter - amount of fixed days that are shown in dropdown even if they do not match a show
* @param {Array} no_special_tags - showtags from db that are excluded when finding "specials"
* @param {Array} tags_hide_from_dropdown - which tags are available for tiles but not for filter dropdown
* @param {Boolean} date_filter_range - true when date filtering goes by ranges more than one day (e.g. week, month, May, October '23, etc)
* @param {Boolean} results_beyond_date - true when all future events are shown beyond the selected date (from this date onwards)
* @param {Boolean} date_presets - true when preset options need to be added to time filter ("Deze week", "Volgende maand", etc)
* @param {Boolean} shows_tags_as_labels
* @param {Boolean} tag_name - slug that is used for the tag filter (e.g. "genres" or "interests")

* Tab configuration
* @param {Object} available_tabs - Object with tabs for this site featuring {slug: title} of the tab
* @param {String} special_tab_sorting - sort special tab movies by either "release-date" or popularity ("populair" )
* @param {String} special_tab_filtering - show all specials ("all-specials") or only those with showtimes ("only-with-times")

*/
const config = {
	agenda: {
		name: 'Cultura Ede',
		theme: 'cultura-ede',
		feedUrl: '/event_feed_json/',
		custom_post_type: 'events',
		multiLanguage: false,
		empty_agenda_text: customData.i18n.empty_agenda_text,
		empty_agenda_subtext: customData.i18n.empty_agenda_subtext,
		empty_agenda_button: customData.i18n.empty_agenda_button,
		agenda_listing_with_months: true,
		sort_by_date: true,
		showtime_undertitle: false,
		filterbar_type: 'overlay',
		has_sorting_option: false,
		sorting_option_mobile_nonemodal: false,
		minimum_days_in_filter: 0,
		date_filter_range: true,
		date_presets: [
			{'from today': 'Vanaf vandaag'},
			{'today': 'Vandaag'},
			{'tomorrow': 'Morgen'},
			{'this weekend': 'Dit weekend'},
			{'this week': 'Deze week'},
			{'this month': 'Deze maand'},
			],
		results_beyond_date: true,
		year_in_tile: true,
		no_special_tags: [],
		tags_hide_from_dropdown: [],
		available_tabs: {},
		special_tab_sorting: '',
		special_tab_filtering: '',
		shows_tags_as_labels: false,
		tag_name: 'interests',
		show_filter_reset: true,
		pagination_pagesize: 12,
	},
	cursus: {
		name: 'Cultura Ede',
		theme: 'cultura-ede',
		feedUrl: '/cursus_feed_json/',
		custom_post_type: 'cursus',
		multiLanguage: false,
		empty_agenda_text: customData.i18n.empty_agenda_text,
		empty_agenda_subtext: customData.i18n.empty_agenda_subtext,
		empty_agenda_button: customData.i18n.empty_agenda_button,
		agenda_listing_with_months: false,
		sort_by_date: false,
		showtime_undertitle: false,
		filterbar_type: 'dropdowns',
		has_sorting_option: false,
		sorting_option_mobile_nonemodal: false,
		minimum_days_in_filter: 0,
		date_filter_range: true,
		date_presets: [
			{'from today': 'Vanaf vandaag'},
			{'today': 'Vandaag'},
			{'tomorrow': 'Morgen'},
			{'this weekend': 'Dit weekend'},
			{'this week': 'Deze week'},
			{'this month': 'Deze maand'},
			],
		results_beyond_date: true,
		year_in_tile: true,
		no_special_tags: [],
		tags_hide_from_dropdown: [],
		available_tabs: {},
		special_tab_sorting: '',
		special_tab_filtering: '',
		shows_tags_as_labels: false,
		tag_name: 'genre',
		show_filter_reset: true,
	},
};

export default config;
